import React from "react";
import SectionHeader from "@/components/SectionHeader";
import { DeviceInfo } from "@/interface/deviceInfo";
import { DiagnosticDetailInterface } from "@/redux/slice/diagnostics/types/fetchDiagnosticsPayload";
import ButtonLink from "@/components/ButtonLink";
import DiagnosticCardsList from "@/components/DiagnosticsWidget/components/DiagnosticCardsList";
import styles from "./DiagnosticsWidget.module.scss";

interface DiagnosticsWidgetProps {
  userAgent?: DeviceInfo;
  data?: any;
  diagnostics: DiagnosticDetailInterface[];
  utm_medium?: string;
}

const DiagnosticsWidget: React.FC<DiagnosticsWidgetProps> = (props) => {
  const { userAgent, data, diagnostics, utm_medium } = props;

  return (
    <div className={`${styles.diagnosticsWidgetRoot}`}>
      <div className="container">
        <SectionHeader title={data?.Title} subTitle={data?.Description} userAgent={userAgent} />
        <DiagnosticCardsList diagnostics={diagnostics} userAgent={userAgent} utm_medium={utm_medium} />
      </div>
      <ButtonLink href={data?.Tests?.[0]?.ViewAllTestsUrl} className={"btn"} color="primarybaby">
        View All Tests
      </ButtonLink>
    </div>
  );
};

export default DiagnosticsWidget;
